/* ============================================================================
   signed-out-caches.js - drop stale “still signed in” storage hints.
   Kept free of auth / profile-ui / ui so landing can clear caches without
   pulling the kitchen shell (Discord invite, mute-all, notifications, …).
   ============================================================================ */

const CLAIM_CACHE_KEY = "ccj_admin_claim_v1";
const SYNC_ATTEMPTED_KEY = "ccj_admin_claim_sync_attempted";

function clearPhotoCacheStorage(uid = null) {
  try {
    sessionStorage.removeItem("ccj_avatar_photo");
    if (uid) {
      localStorage.removeItem(`ccj_photo_${uid}`);
      return;
    }
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const key = localStorage.key(i);
      if (key?.startsWith("ccj_photo_")) localStorage.removeItem(key);
    }
  } catch (_) {}
}

/** Stops home↔vault redirect loops after sign-out / blocked access. */
export function clearSignedOutCaches(uid = null) {
  try {
    sessionStorage.removeItem(CLAIM_CACHE_KEY);
    sessionStorage.removeItem(SYNC_ATTEMPTED_KEY);
    clearPhotoCacheStorage(uid);
    localStorage.removeItem("ccj_last_uid");
    localStorage.removeItem("ccj_last_credits");
    localStorage.removeItem("ccj_last_tier");
    localStorage.removeItem("ccj_preview_auth");
    sessionStorage.removeItem("ccj_last_credits");
    sessionStorage.removeItem("ccj_last_tier");
    sessionStorage.removeItem("ccj_last_uid");
    sessionStorage.removeItem("ccj_last_name");
    sessionStorage.removeItem("ccj_last_email");
    sessionStorage.removeItem("ccj_last_episode");
    sessionStorage.removeItem("ccj_bakeoff_access");
    sessionStorage.removeItem("ccj_avatar_initials");
    sessionStorage.removeItem("ccj_avatar_photo");
    sessionStorage.removeItem("ccj_outfit_lapsed_at");
    sessionStorage.removeItem("ccj_outfit_full_access");
    sessionStorage.removeItem("ccj_admin_mfa_unlocked_until");
    for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
      const key = sessionStorage.key(i);
      if (key && key.indexOf("ccj_products_") === 0) sessionStorage.removeItem(key);
    }
    sessionStorage.removeItem("ccj_cache_vault_grid");
    sessionStorage.removeItem("ccj_cache_vault_filters");
    sessionStorage.removeItem("ccj_vault_live_q");
    sessionStorage.removeItem("ccj_cache_assets_list");
    sessionStorage.removeItem("ccj_cache_assets_meta");
    sessionStorage.removeItem("ccj_cache_overlays_meta");
    sessionStorage.removeItem("ccj_cache_roadmap_grid");
    sessionStorage.removeItem("ccj_access_ok");
    sessionStorage.removeItem("ccj_digital_delivery_consent_v1");
    localStorage.removeItem("ccj_digital_delivery_consent_v1");
    Object.keys(sessionStorage).forEach((key) => {
      if (key.indexOf("ccj_faq_cms_") === 0) sessionStorage.removeItem(key);
    });
  } catch (_) {}
}
